/**
 * engine API
 * engine API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {FieldTable} from '../model/fieldTable';
import {MapOfstringAndstring} from '../model/mapOfstringAndstring';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class EngineStructureService {

    protected basePath = 'https://dmp.airiane.com/services/engine';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     *
     *
     * @param xDataStoreID
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public checkVersioningTriggers(xDataStoreID?: string, body?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<{
        [key: string]: boolean;
    }>;
    public checkVersioningTriggers(xDataStoreID?: string, body?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<{
        [key: string]: boolean;
    }>>;
    public checkVersioningTriggers(xDataStoreID?: string, body?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<{
        [key: string]: boolean;
    }>>;
    public checkVersioningTriggers(xDataStoreID?: string, body?: Array<string>, observe: any = 'body', reportProgress = false): Observable<any> {
        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<{
            [key: string]: boolean;
        }>('put', `${this.basePath}/api/structure/datastore/check-versioning-triggers`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * createField
     *
     * @param xDataStoreID X-DataStoreID
     * @param field field
     * @param table table
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createFieldUsingPOST(xDataStoreID: string, field: FieldTable, table: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public createFieldUsingPOST(xDataStoreID: string, field: FieldTable, table: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public createFieldUsingPOST(xDataStoreID: string, field: FieldTable, table: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public createFieldUsingPOST(xDataStoreID: string, field: FieldTable, table: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling createFieldUsingPOST.');
        }

        if (field === null || field === undefined) {
            throw new Error('Required parameter field was null or undefined when calling createFieldUsingPOST.');
        }

        if (table === null || table === undefined) {
            throw new Error('Required parameter table was null or undefined when calling createFieldUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<boolean>(`${this.basePath}/api/structure/table/${encodeURIComponent(String(table))}/fields`,
            field,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * createSchema
     *
     * @param datastore datastore
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createSchemaUsingPOST(datastore: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public createSchemaUsingPOST(datastore: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public createSchemaUsingPOST(datastore: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public createSchemaUsingPOST(datastore: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (datastore === null || datastore === undefined) {
            throw new Error('Required parameter datastore was null or undefined when calling createSchemaUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<boolean>(`${this.basePath}/api/structure/datastore/${encodeURIComponent(String(datastore))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * createTableToolsDateRange
     *
     * @param xDataStoreID X-DataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createTableToolsDateRangeUsingPOST(xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public createTableToolsDateRangeUsingPOST(xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public createTableToolsDateRangeUsingPOST(xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public createTableToolsDateRangeUsingPOST(xDataStoreID: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling createTableToolsDateRangeUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<any>(`${this.basePath}/api/structure/statistics/daterange`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * createTableToolsStatisticsHistory
     *
     * @param xDataStoreID X-DataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createTableToolsStatisticsHistoryUsingPOST(xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public createTableToolsStatisticsHistoryUsingPOST(xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public createTableToolsStatisticsHistoryUsingPOST(xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public createTableToolsStatisticsHistoryUsingPOST(xDataStoreID: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling createTableToolsStatisticsHistoryUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<any>(`${this.basePath}/api/structure/statistics/statistics_history`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * createTable
     *
     * @param xDataStoreID X-DataStoreID
     * @param table table
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createTableUsingPOST(xDataStoreID: string, table: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public createTableUsingPOST(xDataStoreID: string, table: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public createTableUsingPOST(xDataStoreID: string, table: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public createTableUsingPOST(xDataStoreID: string, table: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling createTableUsingPOST.');
        }

        if (table === null || table === undefined) {
            throw new Error('Required parameter table was null or undefined when calling createTableUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<boolean>(`${this.basePath}/api/structure/table/${encodeURIComponent(String(table))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * createTableWithField
     *
     * @param xDataStoreID X-DataStoreID
     * @param fields fields
     * @param table table
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createTableWithFieldUsingPOST(xDataStoreID: string, fields: Array<FieldTable>, table: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public createTableWithFieldUsingPOST(xDataStoreID: string, fields: Array<FieldTable>, table: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public createTableWithFieldUsingPOST(xDataStoreID: string, fields: Array<FieldTable>, table: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public createTableWithFieldUsingPOST(xDataStoreID: string, fields: Array<FieldTable>, table: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling createTableWithFieldUsingPOST.');
        }

        if (fields === null || fields === undefined) {
            throw new Error('Required parameter fields was null or undefined when calling createTableWithFieldUsingPOST.');
        }

        if (table === null || table === undefined) {
            throw new Error('Required parameter table was null or undefined when calling createTableWithFieldUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<boolean>(`${this.basePath}/api/structure/tableandfields/${encodeURIComponent(String(table))}`,
            fields,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getAllDetailField
     *
     * @param xDataStoreID X-DataStoreID
     * @param table table
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllDetailFieldUsingGET(xDataStoreID: string, table: string, observe?: 'body', reportProgress?: boolean): Observable<Array<MapOfstringAndstring>>;
    public getAllDetailFieldUsingGET(xDataStoreID: string, table: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MapOfstringAndstring>>>;
    public getAllDetailFieldUsingGET(xDataStoreID: string, table: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MapOfstringAndstring>>>;
    public getAllDetailFieldUsingGET(xDataStoreID: string, table: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getAllDetailFieldUsingGET.');
        }

        if (table === null || table === undefined) {
            throw new Error('Required parameter table was null or undefined when calling getAllDetailFieldUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<Array<MapOfstringAndstring>>(`${this.basePath}/api/structure/table/${encodeURIComponent(String(table))}/fields/detail`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getAllField
     *
     * @param xDataStoreID X-DataStoreID
     * @param table table
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllFieldUsingGET(xDataStoreID: string, table: string, observe?: 'body', reportProgress?: boolean): Observable<Array<string>>;
    public getAllFieldUsingGET(xDataStoreID: string, table: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<string>>>;
    public getAllFieldUsingGET(xDataStoreID: string, table: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<string>>>;
    public getAllFieldUsingGET(xDataStoreID: string, table: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getAllFieldUsingGET.');
        }

        if (table === null || table === undefined) {
            throw new Error('Required parameter table was null or undefined when calling getAllFieldUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<Array<string>>(`${this.basePath}/api/structure/table/${encodeURIComponent(String(table))}/fields`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getAllTables
     *
     * @param xDataStoreID X-DataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllTablesUsingGET(xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<Array<string>>;
    public getAllTablesUsingGET(xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<string>>>;
    public getAllTablesUsingGET(xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<string>>>;
    public getAllTablesUsingGET(xDataStoreID: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getAllTablesUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<Array<string>>(`${this.basePath}/api/structure/table`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * removeField
     *
     * @param xDataStoreID X-DataStoreID
     * @param field field
     * @param table table
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeFieldUsingDELETE(xDataStoreID: string, field: string, table: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public removeFieldUsingDELETE(xDataStoreID: string, field: string, table: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public removeFieldUsingDELETE(xDataStoreID: string, field: string, table: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public removeFieldUsingDELETE(xDataStoreID: string, field: string, table: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling removeFieldUsingDELETE.');
        }

        if (field === null || field === undefined) {
            throw new Error('Required parameter field was null or undefined when calling removeFieldUsingDELETE.');
        }

        if (table === null || table === undefined) {
            throw new Error('Required parameter table was null or undefined when calling removeFieldUsingDELETE.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.delete<boolean>(`${this.basePath}/api/structure/table/${encodeURIComponent(String(table))}/fields/${encodeURIComponent(String(field))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * removeSchema
     *
     * @param datastore datastore
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeSchemaUsingDELETE(datastore: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public removeSchemaUsingDELETE(datastore: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public removeSchemaUsingDELETE(datastore: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public removeSchemaUsingDELETE(datastore: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (datastore === null || datastore === undefined) {
            throw new Error('Required parameter datastore was null or undefined when calling removeSchemaUsingDELETE.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.delete<boolean>(`${this.basePath}/api/structure/datastore/${encodeURIComponent(String(datastore))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * removeTable
     *
     * @param xDataStoreID X-DataStoreID
     * @param table table
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeTableUsingDELETE(xDataStoreID: string, table: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public removeTableUsingDELETE(xDataStoreID: string, table: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public removeTableUsingDELETE(xDataStoreID: string, table: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public removeTableUsingDELETE(xDataStoreID: string, table: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling removeTableUsingDELETE.');
        }

        if (table === null || table === undefined) {
            throw new Error('Required parameter table was null or undefined when calling removeTableUsingDELETE.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.delete<boolean>(`${this.basePath}/api/structure/table/${encodeURIComponent(String(table))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Alimente une série de date
     * Les insertions sont ignorées si la date existe en base.
     * @param xDataStoreID X-DataStoreID
     * @param deletePreviousValue Indique si il faut supprimer les anciennes valeurs
     * @param endDate Date de fin YYYY-MM-JJ
     * @param startDate Date de début YYYY-MM-JJ
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateToolsDateRangeUsingPUT(xDataStoreID: string, deletePreviousValue?: boolean, endDate?: string, startDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updateToolsDateRangeUsingPUT(xDataStoreID: string, deletePreviousValue?: boolean, endDate?: string, startDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updateToolsDateRangeUsingPUT(xDataStoreID: string, deletePreviousValue?: boolean, endDate?: string, startDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updateToolsDateRangeUsingPUT(xDataStoreID: string, deletePreviousValue?: boolean, endDate?: string, startDate?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateToolsDateRangeUsingPUT.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (deletePreviousValue !== undefined && deletePreviousValue !== null) {
            queryParameters = queryParameters.set('deletePreviousValue', <any> deletePreviousValue);
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any> endDate);
        }
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any> startDate);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<any>(`${this.basePath}/api/structure/statistics/daterange`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
